module.exports = __webpack_public_path__ + "static/img/suggestion-settings-order-management.0d769fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suggestion-settings-order-management.png
// module id = Y1uH
// module chunks = 134